shadow$provide[104] = function(require,module,exports) {
var require$_DOT__SLASH_bootstrap = require("./bootstrap");
require$_DOT__SLASH_bootstrap.Bootstrap.registerAlias("empty", ["fallback", "bind", "renderer", "size", "fill", "loop", "time",]);
require$_DOT__SLASH_bootstrap.Bootstrap.registerAlias("core", ["empty", "scene", "camera", "render", "warmup",]);
require$_DOT__SLASH_bootstrap.Bootstrap.registerAlias("VR", ["core", "cursor", "fullscreen", "render:vr"]);

};